import { toUtcIsoString } from '@blockworks/platform/libs/moment';

import type { Event } from '@/types/article-type';
import mapWpPosts from '@/utils/functions/wordpress/map-wp-posts';
import optimizeWpRequest from '@/utils/functions/wordpress/utils/optimize-wp-request';
import wpApi from '@/utils/functions/wordpress/wp-api';

const fetchEvents = async (limit = 12, onlyUpcoming = true, includeCustomFields = false): Promise<Event[]> => {
    try {
        const api = wpApi();

        api.events = api.registerRoute('wp/v2', '/events/(?P<id>\\d+)');
        let req = api.events().orderby('date').order('desc');

        if (includeCustomFields) {
            req = req.embed();
        }
        let events;

        // Only attempt to optimize requests made on the server
        if (typeof window !== 'undefined') {
            events = await req.perPage(limit);
        } else {
            events = await optimizeWpRequest.events({ baseReq: req, limit });
        }

        if (!events) {
            return [];
        }

        return mapWpPosts(
            onlyUpcoming ? events.filter((w: any) => new Date(w.acf?.date_and_time) > new Date()) : events,
        )
            .filter(event => event.customFields.is_master_event)
            .map((event: any) => {
                const eventStartDate = toUtcIsoString(event.customFields.date_and_time);
                const eventEndDate = toUtcIsoString(event.customFields.date_and_time_end);

                return {
                    ...event,
                    eventStartDate,
                    eventEndDate,
                };
            }) as Event[];
    } catch (err) {
        console.error('fetchEvents', err);
        return [];
    }
};

export default fetchEvents;
